import { Collapse } from 'antd-v5';
import React from 'react';
import { useLang } from '@/app/utils/useLang';

const FAQ: React.FC = ({}) => {
    const { t } = useLang('recall.FAQ');
    const Panel = Collapse.Panel;
    return (
        <Collapse className="recall-faq" ghost>
            <Panel header={t('title')} key="1">
                <div>
                    <div className="faq-title">{t('label1')}</div>
                    <div className="faq-content">
                        {t.rich('content1', {
                            l: (v: string) => (
                                <a className="recall-link" href="efdelta-discharge-information" target="_blank" rel="noreferrer">
                                    {v}
                                </a>
                            ),
                        })}
                    </div>
                </div>
                <div>
                    <div className="faq-title">{t('label2')}</div>
                    <div className="faq-content">{t('content2')}</div>
                </div>
                <div>
                    <div className="faq-title">{t('label3')}</div>
                    <div className="faq-content">{t('content3')}</div>
                </div>
                <div>
                    <div className="faq-title">{t('label4')}</div>
                    <div className="faq-content">
                        {t.rich('content4', {
                            b: (v: string) => <span className="fw-700">{v}</span>,
                        })}
                    </div>
                </div>
                <div>
                    <div className="faq-title">{t('label5')}</div>
                    <div className="faq-content">{t('content5')}</div>
                </div>
                <div>
                    <div className="faq-title">{t('label6')}</div>
                    <div className="faq-content">{t('content6')}</div>
                </div>
                <div>
                    <div className="faq-title">{t('label7')}</div>
                    <div className="faq-content">
                        {t.rich('content7', {
                            l: (v: string) => (
                                <a className="recall-link" href="efdelta-discharge-information" target="_blank" rel="noreferrer">
                                    {v}
                                </a>
                            ),
                        })}
                    </div>
                </div>
                <div>
                    <div className="faq-title">{t('label8')}</div>
                    <div className="faq-content">{t('content8')}</div>
                </div>
                <div>
                    <div className="faq-title">
                        {t.rich('label9', {
                            l: (v: string) => (
                                <a className="recall-link" href="https://jp.ecoflow.com/pages/efdelta1300-jp-information" target="_blank" rel="noreferrer">
                                    {v}
                                </a>
                            ),
                        })}
                    </div>
                    <div className="faq-content">{t('content9')}</div>
                </div>
                <div>
                    <div className="faq-subTitle">
                        2023年10月20日付けで実施しております自主回収、製品交換対応の窓口と、2025年1月6日より公開した自主回収、交換プログラムの窓口を統合いたしました。窓口の統合により、お客様の利便性を高め、今回自主回収、交換プログラムにおいてよりスムーズなご対応の提供が可能です。
                    </div>
                </div>
                <div>
                    <div className="faq-title">{t('label10')}</div>
                    <div className="faq-content">{t('content10')}</div>
                </div>
                <div>
                    <div className="faq-title">{t('label11')}</div>
                    <div className="faq-content">{t('content11')}</div>
                </div>
                <div>
                    <div className="faq-subTitle">{t('label12')}</div>
                    <div className="faq-content">{t('content12')}</div>
                    <ul className="faq-list">
                        <li>{t('content12_1')}</li>
                        <li>{t('content12_2')}</li>
                        <li>{t('content12_3')}</li>
                    </ul>
                </div>
                <div>
                    <div className="faq-subTitle">{t('label13')}</div>
                    <div className="faq-content">{t('content13')}</div>
                    <ul className="faq-list">
                        <li>{t('content13_1')}</li>
                        <li>{t('content13_2')}</li>
                        <li>{t('content13_3')}</li>
                        <li>{t('content13_4')}</li>
                    </ul>
                </div>
                <div>
                    <div className="faq-content">
                        何かご質問や不明な点等ございましたら、下記のお問い合わせ窓口までご連絡ください。
                        <br />
                        本件に関するお問い合わせ
                    </div>
                </div>
            </Panel>
        </Collapse>
    );
};
export default FAQ;
